'use client'

import { useScrollAnimation } from '@/hooks/use-scroll-animation'
import { useI18n } from '@/components/i18n-provider'

const APPLE_EASE = 'ease-[cubic-bezier(0.28,0.11,0.32,1)]'

export function HowItWorksSection() {
  const { t } = useI18n()
  const { elementRef: titleRef, isVisible: titleVisible } = useScrollAnimation()
  const { elementRef: stepsRef, isVisible: stepsVisible } = useScrollAnimation({ threshold: 0.1 })

  const steps = [
    { title: t('how.steps.provide.title'), description: t('how.steps.provide.desc') },
    { title: t('how.steps.analyze.title'), description: t('how.steps.analyze.desc') },
    { title: t('how.steps.plan.title'), description: t('how.steps.plan.desc') },
  ]

  return (
    <section className="bg-background py-24 sm:py-28">
      <div className="container">
        <div
          ref={titleRef}
          className={`mx-auto mb-16 max-w-2xl text-center transition-all duration-700 ${APPLE_EASE} ${
            titleVisible ? 'translate-y-0 opacity-100' : 'translate-y-5 opacity-0'
          }`}
        >
          <h2 className="text-3xl font-semibold tracking-[-0.02em] text-foreground sm:text-5xl">
            {t('how.title')}
          </h2>
        </div>

        <div
          ref={stepsRef}
          className="mx-auto grid max-w-4xl grid-cols-1 gap-12 text-center md:grid-cols-3 md:gap-10"
        >
          {steps.map((step, index) => (
            <div
              key={index}
              className={`transition-all duration-500 ${APPLE_EASE} ${
                stepsVisible ? 'translate-y-0 opacity-100' : 'translate-y-6 opacity-0'
              }`}
              style={{ transitionDelay: stepsVisible ? `${index * 150}ms` : '0ms' }}
            >
              <div className="tabular text-5xl font-semibold tracking-tight text-foreground/[0.12] dark:text-white/[0.15]">
                {String(index + 1).padStart(2, '0')}
              </div>
              <h3 className="mt-4 text-xl font-semibold tracking-tight text-foreground">
                {step.title}
              </h3>
              <p className="mx-auto mt-2 max-w-xs leading-relaxed text-muted-foreground">
                {step.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
